export const buttonStyleElements = {
  confirmButtonStyle: {
    backgroundColor: "#fea116",
    color: "white",
    fontSize: "12px",
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
    textDecoration: "none",
    display: "inline-block",
    textAlign: "center",
    transition: "background-color 0.3s ease",
  },
  confirmBtnStyle: {
    backgroundColor: "#fea116",
    fontSize: "25px",
    color: "white",
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "background-color 0.3s ease",
  },
  deleteButtonStyle: {
    backgroundColor: "#dc3545",
    fontSize: "25px",
    color: "white",
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "background-color 0.3s ease",
  },
  paymentButtonStyle: {
    backgroundColor: "#22C55E",
    fontSize: "25px",
    color: "white",
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "background-color 0.3s ease",
  },
  detailButtonStyle: {
    backgroundColor: "#fea116",
    fontSize: "25px",
    color: "white",
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "background-color 0.3s ease",
  },
};
